/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class DashboardReportCreateRequest {
    getFixupPrototypeFunction() { return DashboardReportCreateRequest.fixupPrototype; }

    static newInstance(model: Partial<DashboardReportCreateRequest>): DashboardReportCreateRequest {
        let obj = Object.assign(new DashboardReportCreateRequest(), model);
        DashboardReportCreateRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<DashboardReportCreateRequest>): DashboardReportCreateRequest {
        if (!model) return null;
        return DashboardReportCreateRequest.newInstance(<DashboardReportCreateRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: DashboardReportCreateRequest) {
        if (!obj) return;

        models.DashboardReportCreateRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: DashboardReportCreateRequest): boolean {
        Object.setPrototypeOf(obj, DashboardReportCreateRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.report_configuration) {
            models.ReportConfigurationForExecutiveDashboard.fixupPrototype(this.report_configuration);
        }
    }

    /**
     * Report configuration to generate report
     */
    report_configuration: models.ReportConfigurationForExecutiveDashboard;

}
